module.exports = __webpack_public_path__ + "static/media/github.ec5bc1b3.svg";